/* jshint -W024 */
// checkout script extends default script
import "./default";

// =========================
// Common
// =========================
import "./app/eros/common/mobileStickyButtons";

// =========================
// External Plugins
// =========================
// import "./app/eros/plugins/external/qrcode";

// =========================
// COMPONENTS
// =========================
import "./app/eros/components/checkout/AcceptGtcCheck";
import "./app/eros/components/checkout/Checkout";
import "./app/ceres/components/checkout/ContactWishInput";
import "./app/ceres/components/checkout/CustomerSignInput";
import "./app/eros/components/checkout/PaymentProviderSelect";
import "./app/eros/components/checkout/PlaceOrder";
import "./app/eros/components/checkout/ShippingPrivacyHintCheck";
import "./app/eros/components/checkout/ShippingProfileSelect";
import "./app/ceres/components/checkout/SubscribeNewsletterCheck";
import BasketItemConsentCheck from "./app/ceres/components/checkout/BasketItemConsentCheck.vue";
Vue.component("basket-item-consent-check", BasketItemConsentCheck);

import "./app/eros/components/customer/AddressSelect/AddressHeader";
import "./app/eros/components/customer/AddressSelect/InvoiceAddressSelect";
import "./app/eros/components/customer/AddressSelect/ShippingAddressSelect";

import "./app/ceres/components/myAccount/AccountSettings";
import "./app/ceres/components/myAccount/BankDataSelect";
import "./app/eros/components/myAccount/ChangePaymentMethod";
import "./app/eros/components/myAccount/CancelOrder";
import "./app/ceres/components/myAccount/MyAccount";
import "./app/ceres/components/myAccount/OrderDocuments";

import ShippingCountrySelect from "./app/eros/components/pageDesign/ShippingCountrySelect.vue";
Vue.component("shipping-country-select", ShippingCountrySelect);
import BasketPreview from "./app/eros/components/basket/BasketPreview.vue";
Vue.component("basket-preview", BasketPreview);
import BasketTotals from "./app/eros/components/basket/BasketTotals.vue";
Vue.component("basket-totals", BasketTotals);
Vue.component("mail-changed-info", () => import("./app/ceres/components/basket/MailChangedInfo.vue"));
import Coupon from "./app/eros/components/basket/Coupon.vue";
Vue.component("coupon", Coupon);
import CouponToggle from "./app/eros/components/basket/CouponToggle.vue";
Vue.component("coupon-toggle", CouponToggle);
import BasketList from "./app/eros/components/basket/list/BasketList.vue";
Vue.component("basket-list", BasketList);
import BasketExtraItem from "./app/eros/components/basket/BasketExtraItem.vue";
Vue.component("basket-extra-item", BasketExtraItem);
import ShopVoteBadge from "./app/eros/components/checkout/ShopVoteBadge.vue";
Vue.component("shop-vote-badge", ShopVoteBadge);
import ConvertAccount from "./app/eros/components/checkout/ConvertAccount.vue";
Vue.component("convert-account", ConvertAccount);
import GiroPayQr from "./app/eros/components/myAccount/GiroPayQr.vue";
Vue.component("giro-pay-qr", GiroPayQr);

// legacy non-shopbuilder components
import "./app/ceres/components/myAccount/History";

// new shopbuilder-only component
import EditCouponOverlay from "./app/ceres/components/myAccount/EditCouponOverlay.vue";
Vue.component("edit-coupon-overlay", EditCouponOverlay);
import "./app/eros/components/myAccount/OrderHistoryList";
import "./app/ceres/components/myAccount/OrderReturnHistoryList";

Vue.component("modal-login-view", () => import("./app/eros/components/customer/login/ModalLoginView.vue"));
Vue.component("login-check-view", () => import("./app/eros/components/customer/login/LoginCheckView.vue"));

// since basket isn't tpl.basket
// Vue.component("dynamic-item-list-basket", () => import("./app/eros/components/itemList/DynamicItemListBasket.vue"));

Vue.component("dynamic-item-list-confirmation", () =>
	import("./app/eros/components/itemList/dynamicItemList/Confirmation/DynamicItemListConfirmation.vue")
);

Vue.component("order-confirmation", () => import("./app/eros/components/checkout/OrderConfirmation.vue"));
Vue.component("FeedbackOrderContainer", () => import("./app/eros/plugins/plentymarkets/feedback/components/order/FeedbackOrder.vue"));

Vue.component("add-to-basket", () => import("./app/eros/components/basket/AddToBasket.vue"));
Vue.component("progress-indicator", () => import("./app/eros/components/common/ProgressIndicator.vue"));

// =========================
// FILTERS
// =========================
import "./app/ceres/filters/truncate.filter";
import "./app/ceres/filters/date.filter";
import "./app/ceres/filters/itemBundleName.filter";
